<template>
  <div ref="content">

     <div class="nonPrint" style="margin-top: 20px;">
      <v-toolbar dark class="toolbarcreatedadmin nonPrint" style="margin-top: 20px;">
      <v-btn icon @click="routeinfo()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>รายละเอียดข้อมูล QR code</v-toolbar-title>
    </v-toolbar>
  </div>


    <div class="nonPrint" style="margin-top: 20px;">
    <table class="tableInfor">
      <tr>
        <td class="div_infor_header">Generate ID:</td>
        <td class="div_infor" colspan="3">{{data_generate.generate_id}}</td>
      </tr>
      <tr>
        <td class="div_infor_header">บริษัทเจ้าของ:</td>
        <td class="div_infor">{{ data_generate.company_owner_name }}</td>
        <td class="div_infor_header">บริษัทที่ดูแล:</td>
        <td class="div_infor">{{ data_generate.company_maintenance_name }}</td>
      </tr>
      <tr>
        <td class="div_infor_header">ผู้สร้าง:</td>
        <td class="div_infor">{{ (data_generate.create_by == 'null null')? '-':data_generate.create_by }}</td>
        <td class="div_infor_header">วัน เวลา ที่สร้าง:</td>
        <td class="div_infor">{{ momentdatethai(data_generate.create_at)}} {{ momenttimethai(data_generate.create_at)}}น.</td>
      </tr>
    </table>

    <table class="tableInfor" style="margin-top: 15px;">
      <tr>
        <td class="div_infor_headerDetail">Serial No:</td>
        <td class="div_infor">{{ (data_generate.qrcode_data[0].serial_number)? (data_generate.qrcode_data[0].serial_number): '-'}}</td>
        <td class="div_infor_headerDetail">อายุ battery:</td>
        <td class="div_infor">{{ (data_generate.qrcode_data[0].battery_expire)? (data_generate.qrcode_data[0].battery_expire): '-'}}</td>
        <td class="div_infor_headerDetail">อายุ pad:</td>
        <td class="div_infor">{{ (data_generate.qrcode_data[0].pad_expire)? (data_generate.qrcode_data[0].pad_expire): '-'}}</td>
      </tr>
    </table>
<div class="nonPrint positionPrint" >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="ma-2" outlined fab small color="#a80f00" @click="print()" v-on="on">
        <img :src="BASE_URL + 'static/iconButton/printing.png'" alt="" width="25px">
      </v-btn>
        </template>
        <span class="nonPrint">Print</span>
      </v-tooltip>
  </div>
  <div class="pageBreak">

    <v-layout wrap style="margin-bottom: 20px;">
        

          <v-card class="border-color" v-for="(item,index) in data_generate.qrcode_data" style="margin-bottom: 10px;">

            <qrcode :value="API_FRONTEND + 'AEDQRcode/' + item.qrcode_id" style="width: 30vh;" ></qrcode>

            <br v-if="item.serial_number">
            <v-chip small v-if="item.serial_number">{{item.serial_number}}</v-chip>
            <br v-if="item.aed_id">
            <v-chip small v-if="item.aed_id">มีเครื่อง AED แล้ว</v-chip>

            <br>
            <v-btn class="ma-2" outlined  small color="#a80f00" @click="detail_aed(item.aed_id)" v-if="item.aed_id">ดูข้อมูล</v-btn>
            <v-btn class="ma-2" style="background: #a80f00 !important; color: white;" small @click="delete_qrcode(item.qrcode_id,index)" v-else>ลบ</v-btn>
          </v-card>

      </v-layout>



     </div>
    </div>



    <!-- <div id="PDF" style="justify-content: center;display: flex;"> -->
      <!-- <div style="justify-content: center;display: flex;"> -->
      <!-- <div  style="display: flex;" class="pageBreak"> -->
        <!-- <v-layout row wrap> -->
      <!-- <v-flex xs4 sm4 md4 lg4 xl4 v-for="item in data_generate.qrcode_data"> -->
        <!-- <div v-for="item in data_generate.qrcode_data"> -->
       <!-- <qrcode v-for="item in data_generate.qrcode_data" :value="API_FRONTEND + 'AEDQRcode/' + item.qrcode_id" style="height: 20vh;width: 20vw;">test</qrcode> -->
     <!-- <qrcode-vue :value="API_FRONTEND + 'AEDQRcode/' + item.qrcode_id" :size="200" level="M" renderAs="svg" ></qrcode-vue> -->

       <!-- <v-chip small v-if="item.serial_number" >{{item.serial_number}}</v-chip> -->
     <!-- </div> -->
     <!-- </v-flex> -->
   <!-- </v-layout> -->


<!-- 
     </div>
   </div> -->

       <div id="PDF">
        <!-- style=" display: inline-flex;" -->
      <div class="pageBreak" style="border: 4px solid #a80e00; border-radius: 10px; width: 35vh;margin-top: 5px;" v-for="item in data_generate.qrcode_data">
       <qrcode :value="API_FRONTEND + 'AEDQRcode/' + item.qrcode_id" style="width: 30vh;margin: auto;" ></qrcode>
       <p style="color:#a80e00 !important; font-weight: 600;" v-if="item.serial_number" >{{item.serial_number}}</p>




     </div>
   </div>





  </div>
</template>

<script>
var _ = require('lodash')
var moment = require('moment')
import QrcodeVue from 'qrcode.vue'
import { Decode, Momenttime } from '@/services'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      API_FRONTEND: process.env.API_FRONTEND,
      generate_id: '',
      authen: {},
      headerAPI: {},
      data_generate: {}
    }
  },
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.generate_id = this.$route.query.id
    this.getQrcode()
  },
  mounted () {
  },
  components: {
    QrcodeVue
  },
  computed: {
  },
  methods: {
    routeinfo () {
      this.$router.push('/information/qrcode')
      // this.$router.back()
      // history.go(-1)
    },
    //  momentdatethai (data) {
    //   return moment(data).tz('Asia/Bangkok').lang('th').format('ll')
    // },
    // momenttimethai (data) {
    //   return (moment(data).tz('Asia/Bangkok').lang('th').format('LT'))
    // },
    momentdatethai(data) {
      return Momenttime.momentdatethai(data)
    },
    momenttimethai(data) {
      return Momenttime.momenttimethai(data)
    },
    print () {
      window.print()
    },
    detail_aed (aed_id) {
      this.$router.push('/information_aed?id='+aed_id)
    },
    delete_qrcode (qrcode_id, index) {
      var body = {
        qrcode_id: qrcode_id
      }
      this.$swal({
        title: 'คุณแน่ใจหรือไหม?',
        text: 'คุณกำลังลบ QR Code นี้!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่, ฉันแน่ใจ!',
        cancelButtonText: 'ไม่ใช่, ยกเลิก!',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.API_BACKEND + '/v1/deleteQrCode', body, { headers: this.headerAPI }).then((response) => {
            if (response.data.message == 'success') {
              if (index >= 0) {
                this.data_generate.qrcode_data.splice(index, 1)
                this.$swal('', 'QR Code ถูกลบแล้ว', 'success')
                if (this.data_generate.qrcode_data.length == 0) {
                  this.routeinfo()
                }
              }
            }
          })
        }
      })

      // this.axios.post(process.env.API_BACKEND + '/v1/deleteQrCode', body, { headers: this.headerAPI }).then((response) => {
      //   if (response.data.message == 'success') {
      //     if (index >= 0) {
      //       this.data_generate.qrcode_data.splice(index, 1)
      //     }
      //   }
      // })
    },
    getQrcode () {
      var body = {
        generate_id: this.generate_id
      }
      this.axios.post(process.env.API_BACKEND + '/v1/getListGenerateQrCodeByGenerateID', body, { headers: this.headerAPI }).then((response) => {
        this.data_generate = response.data.data
        // this.data_generate.qrcode_data[0].serial_number = 'akjksjkjsk'
        // this.data_generate.qrcode_data[1].serial_number = 'akjksjkjsk'
      })
    },
    showdetailTable (data) {
      if (data.serial_number !== null && data.serial_number !== '') {
        return true
      } else if (data.pad_expire !== null && data.pad_expire !== '') {
        return true
      } else if (data.battery_expire !== null && data.battery_expire !== '') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style media="screen" scoped>
.border-color {
  margin-right: 15px !important;
  border-radius: 11px !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-style: solid !important;
  border-width: medium !important;
  border-color: #a80e00 !important;
}
  >>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .inputinfor_address {
    height: 110px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor_dis {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: #FAF0F0 !important;
  }
  >>>.theme--dark.v-select .v-select__selections {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-label {
      color: hsl(5, 100%, 33%) !important;
  }
  >>>.theme--dark.v-icon {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: #a80e00 !important;
  }
  .toolbarcreatedadmin {
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-width: thin !important;
    border-right-color: transparent !important;
    border-style: solid !important;
    height: 64px !important;
    border-left-style: initial !important;
    border-right-style: initial !important;
    border-radius: 0px !important;
    border-bottom-color: #a80e00 !important;
    background-color: white !important;
    color: #a80e00 !important;
    border-width: thin !important;
    box-shadow: none !important;
  }
  .btngen {
    background-color: white !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
    width: 120px !important;
  }
  .btncreateuser {
    background-color: #a80f00 !important;
    color: #fafafa !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
  }
  .btncreateuser:disabled {
    background-color: #a80f0099 !important;
    color: #fafafa9c !important;
    border-color: #a80f0091 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

  .btncancle {
    background-color: #fafafa !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    width: 160px !important;
  }

  .div_infor_header {
    width: 10vw;
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 20px;
  }
  .div_infor {
    width: 20vw;
    border: solid 1px #a80d00;
    text-align: left;
    padding-left: 20px;
  }
  .div_infor_headerDetail {
    width: 10vw;
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 10px;
  }
  .tableInfor {
    justify-content: center;
    display: inline-table;
    width: 70vw;
  }
  .positionPrint {
    width: 70vw;
      margin-left: 30vw;
      text-align: right;
      padding-right: 16vw;
  }
  @media screen {
    #PDF {
      /*height: 60vh !important;
      overflow: scroll;*/
      display: none;
    }
    .nonPrint {
      overflow: scroll;
    }
  }
  @media print {
   /* body {
      overflow-y: visible;
      position: fixed;
      position: absolute;
    }*/
    .nonPrint {
      display: none;
    }
    #PDF {
      /*width: 100%;
height:100%;
position:absolute;
top:0px;
bottom:0px;
margin: auto;
margin-top: 0px !important;*/
      width: 100%;
      overflow: hidden;
      float: none;
      display: block;
      -webkit-print-color-adjust: exact; 
    }
    .pageBreak { page-break-inside:always;}
    .pageBreak * {
      /*page-break-inside:avoid;break-inside: avoid;*/
      page-break-after:avoid;
      page-break-before:avoid;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/information_print/infor_groupqrcode.vue